<footer class="footer">
	<div class="inner">
		<nav class="footer-links" aria-label="Legal and policy links">
			<a href="/privacy">Privacy Policy</a>
			<a href="/privacy#photos">How We Handle Your Photos</a>
			<a href="/terms">Terms of Use</a>
			<a href="/delete-account">Delete My Data</a>
		</nav>
		<div class="disclosures">
			<p>
				SkinGenie gives skincare product suggestions, not medical advice. It can't diagnose a
				skin condition. If something on your skin is painful, changing, or not improving, please
				see a dermatologist.
			</p>
			<p>
				As an Amazon Associate, SkinGenie earns from qualifying purchases. Product prices and
				availability are subject to change.
			</p>
		</div>
		<p class="copyright">Copyright &copy; 2026 SkinGenie.AI</p>
	</div>
</footer>

<style>
	.footer {
		padding: var(--space-16) var(--page-pad-x);
		background: var(--bg);
		border-top: 1px solid var(--border);
		font-family: var(--font-body);
		text-align: center;
	}

	.inner {
		max-width: var(--content-max);
		margin: 0 auto;
	}

	/* One calm row of links, closed by a hairline. */
	.footer-links {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: var(--space-3) var(--space-8);
		padding-bottom: var(--space-6);
		border-bottom: 1px solid var(--border);
	}

	.footer-links a {
		color: var(--text-muted);
		font-size: var(--text-2xs);
		letter-spacing: var(--track-label);
		text-transform: uppercase;
		transition: color var(--transition);
	}

	.footer-links a:hover {
		color: var(--cream);
	}

	/* Required disclosure, not an error message: muted ink at body scale,
	   no accent colour and no opacity knocking it back further. */
	.disclosures {
		max-width: var(--prose-max);
		margin: var(--space-8) auto 0;
	}

	.disclosures p {
		margin: 0 0 var(--space-4);
		font-size: var(--text-xs);
		line-height: var(--leading-normal);
		color: var(--text-muted);
	}

	.copyright {
		margin: var(--space-8) 0 0;
		font-size: var(--text-2xs);
		letter-spacing: var(--track-label);
		text-transform: uppercase;
		color: var(--text-muted);
	}
</style>
